import { FoodsSelect } from "@foodpilot/foods";
import { useTranslation } from "react-i18next";
import { useLanguage } from "src/context/LanguageProvider";
import { useMemo } from "react";

export const LanguageSelector = () => {
    const { t } = useTranslation();
    const { currentLanguage, enabledLanguages, isLoading, changeLanguage } = useLanguage();

    const languageChoice = useMemo(() => {
        if (!enabledLanguages || enabledLanguages.length === 0) {
            return [];
        }

        return enabledLanguages
            .filter((locale) => locale.code) // Filter out locales without code
            .map((locale, index) => {
                const code = locale.code!; // We filtered nulls above
                const displayName = locale.nativeName || locale.name || code;
                const flagIcon = locale.flag ? <span>{locale.flag}</span> : <span>🌐</span>;

                return {
                    id: locale.id || index + 1,
                    lng: code,
                    name: displayName || code,
                    icon: flagIcon,
                };
            });
    }, [enabledLanguages]);

    const currentLanguageOption =
        languageChoice.find((lng) => lng.lng === currentLanguage) ?? languageChoice[0] ?? null;

    return (
        <FoodsSelect
            selectedOption={currentLanguageOption}
            options={languageChoice}
            onChange={(selectedValue) => {
                if (selectedValue === null) return;
                changeLanguage(selectedValue.lng);
            }}
            getId={(item) => item.id}
            getName={(item) => item.name}
            getIcon={(item) => item.icon}
            disabled={isLoading}
            textOptions={{
                noResult: "",
                searchPlaceholder: "",
                emptyOptionsText: t("select.generic.no_options"),
                placeholder: isLoading ? t("select.generic.loading", "Loading...") : t("select.generic.placeholder"),
            }}
        />
    );
};
